import { localisedValue } from "utils"

const calculateTotalFeatureCharges = (features, unitPrice) => {
  return features.reduce(
    (acc, item) => acc + (item?.amountType === "fixed" ? item?.amount : (item?.amount * unitPrice) / 100),
    0
  )
}

const leadsTransfomer = response => {
  let istokenZero = response?.salesEventToken

  let lastTask = response?.tasks?.find(item => item.hasOwnProperty("todoDetails"))
  const statusKey = response?.inquiry?.InternalInquiryStatus?.key
  const isLocationCompanyOffices = ["company_office", "company_office_meeting_attempted", "walk_in"]?.includes(
    statusKey
  )
  const isLocationSiteProjects = ["site_office", "site_office_meeting_attempted"]?.includes(statusKey)

  if (response.contracts.length === 0) {
    return {
      ...response,
      current: undefined,
      isToken: false,
      clientId: response.inquiry.Client.id,
      inquiryStatusDetails: {
        ...response?.inquiryStatusDetails,
        ...(!response?.inquiryStatusDetails?.nextStatusId && {
          nextStatusId: response?.tasks?.[0]?.Todo?.nextStatusId,
        }),
      },
      lastTask: lastTask,
      nextTask: lastTask?.todoDetails,
      doesCNICExist: !!response.inquiry.Client.nationalId,
      doesCountryExist: !!response.inquiry.Client.Country,
      doesCityExist: !!response.inquiry.Client.City,
      doesNationalityExist: !!response.inquiry.Client.Nationality,
      doesDOBExist: !!response.inquiry.Client.dateOfBirth,
      isFirstSalesTask: true,
      statusIsReserved: response?.ReservationQueuedAgainstLead?.status === "reserved",
      isReserved: response?.ReservationQueuedAgainstLead?.isReserved,
      isReservedWithReservedStatus:
        response?.ReservationQueuedAgainstLead?.isReserved &&
        response?.ReservationQueuedAgainstLead?.status === "reserved",
      isReservedWithPendingStatus:
        response?.ReservationQueuedAgainstLead.isReserved && response.ReservationQueuedAgainstLead.status === "pending",
      isLocationCompanyOffices,
      isLocationSiteProjects,
    }
  } else {
    return {
      ...response,
      lastTask: lastTask,
      nextTask: lastTask?.todoDetails,
      clientName: response.inquiry.Client?.name,
      verifiedWon: response.inquiry.verifiedClosedWon,
      project: response.contracts[0].project,
      projectName: localisedValue({ object: response.contracts[0].project, key: "name" }),
      projectId: response.contracts[0].projectId,
      projectUrl: response?.contracts[0]?.project?.url,
      features: response?.contracts[0]?.features.map(feature => ({
        ...feature,
        key: feature?.id,
        Feature: feature?.name,
        fixed: 1,
        numberComponentRequired: true,
      })),
      unitPrice: response.contracts[0].unitPrice,
      totalFeatureCharges: calculateTotalFeatureCharges(
        response?.contracts[0]?.features,
        response?.contracts[0]?.unitPrice
      ),
      projectBookingForm: response?.contracts[0]?.project?.needsBookingForm,
      type: localisedValue({ object: response.contracts[0].Type, key: "name" }),
      paymentProcessingState: response?.contracts[0]?.isInPaymentProcessingState,
      contractId: response.contracts[0].contractId,
      contractExpiry: response.contracts[0].expiryDate,
      unitDiscount: response.contracts[0].dealDiscount,
      paidAmount: response.contracts[0].paymentProgress.amountReceived,
      dealPrice: response.contracts[0].dealPrice,
      dueAmount: response.contracts[0].paymentProgress.amountDue,
      unitId: response.contracts[0].listingId,
      unitName: response?.contracts[0]?.Listing?.unitNumber,
      listingId: response.contracts[0].listingId,
      doesClientExist: !!response.inquiry.Client,
      doesCNICExist: !!response.inquiry.Client.nationalId,
      doesCountryExist: !!response.inquiry.Client.Country,
      doesCityExist: !!response.inquiry.Client.City,
      doesNationalityExist: !!response.inquiry.Client.Nationality,
      doesDOBExist: !!response.inquiry.Client.dateOfBirth,
      countryId: response.inquiry.Client.Country.id,
      remainMinToken:
        istokenZero || !!response?.contracts?.[0]?.paymentProgress?.vasContractDetails?.hasPendingPayment
          ? 0
          : response.contracts[0].paymentProgress?.minTokenUnit === "percentage"
          ? (response.contracts[0].dealPrice * response.contracts[0].paymentProgress?.minToken) / 100
          : response.contracts[0].paymentProgress?.remainingMinimumTokenAmount,
      remainParDowPayment: response.contracts[0].paymentProgress?.remainingPartialDownPaymentAmount,
      remainComDowPayment: response.contracts[0].paymentProgress?.remainingCompleteDownPaymentAmount,
      document: response.documents[0],
      token: response.contracts[0].paymentProgress?.minToken,
      tokenPercentage: response.contracts[0].paymentProgress?.minToken / 100,
      tokenUnit: response.contracts[0].paymentProgress?.minTokenUnit,
      cdp: response.contracts[0].paymentProgress?.completeDownPaymentInPercentage,
      pdp: response.contracts[0].paymentProgress?.partialDownPaymentInPercentage,
      pdpPercentage: response.contracts[0].paymentProgress?.partialDownPaymentInPercentage * 0.01,
      cdpPercentage: response.contracts[0].paymentProgress?.completeDownPaymentInPercentage * 0.01,
      contractType: response.contracts[0].ContractType?.key,
      hasMultipleSalesTasks: true,
      current:
        response?.contracts?.[0]?.paymentProgress?.vasContractDetails?.hasPendingPayment === true
          ? 0
          : response.inquiry.verifiedClosedWon !== 0
          ? 5
          : response.inquiry.InternalInquiryStatus.key === "closed_won" &&
            response.contracts[0].paymentProgress?.remainingCompleteDownPaymentAmount === 0
          ? 4
          : response.contracts[0].paymentProgress?.remainingCompleteDownPaymentAmount === 0
          ? 3
          : response.contracts[0].paymentProgress?.remainingPartialDownPaymentAmount === 0
          ? 2
          : response.contracts[0].paymentProgress?.amountReceived === 0 && !response?.contracts?.[0]?.paymentProgress?.vasContractDetails
          ? 0
          : 1,

      isLocationCompanyOffices,
      isLocationSiteProjects,
      statusIsReserved: response?.ReservationQueuedAgainstLead?.status === "reserved",
      isReserved: response?.ReservationQueuedAgainstLead?.isReserved,
      isReservedWithReservedStatus:
        response?.ReservationQueuedAgainstLead?.isReserved &&
        response?.ReservationQueuedAgainstLead?.status === "reserved",
      isReservedWithPendingStatus:
        response?.ReservationQueuedAgainstLead.isReserved && response.ReservationQueuedAgainstLead.status === "pending",
      isVasRemaining: response?.contracts?.[0]?.paymentProgress?.vasContractDetails?.hasPendingPayment,
      vasRemianingAmount:
        response?.contracts?.[0]?.paymentProgress?.vasContractDetails?.paymentProgress?.amountRemaining,
      vasContractId: response?.contracts?.[0]?.paymentProgress?.vasContractDetails?.vasContractId,
    }
  }
}

export default leadsTransfomer
